























































import echarts from 'echarts'
import { datetimeOption } from '@/utils/tool'
import { Vue, Component, Prop } from 'vue-property-decorator'
interface option {
  value: string
  text: string
}
interface priceItem {
  count: number
  date: number
}
@Component({
  name: 'MultiDataChart'
})
export default class extends Vue {
  @Prop({ required: true }) option!: any
  @Prop({ required: true }) title!: string
  @Prop({ required: false }) tableData!: priceItem[]

  options: option[] = [
    {
      text: '本周',
      value: 'week'
    },
    {
      text: '本月',
      value: 'month'
    },
    {
      text: '本年',
      value: 'year'
    }
  ]

  dateTime: string[] = datetimeOption('week')

  params: any = {
    currentOption: 'week'
  }

  show: boolean = true

  // mounted
  mounted() {
    this.drawChart()
  }

  // methods
  drawChart() {
    let myChart = echarts.init(this.$refs.chart as HTMLDivElement)
    myChart.setOption(this.option)
  }

  handledateChange(val: string) {
    this.$emit('date-change', [val, this.drawChart])
  }
  handleChange(val: string) {
    this.dateTime = datetimeOption(val)
    this.$emit('date-change', [this.dateTime, this.drawChart])
  }
}
